
import { Component, Prop, Vue } from 'vue-property-decorator'

import FeedbackType from '@/shared/enums/FeedbackType'
import Step from '@/shared/enums/Step'

import EButton from './Button.vue'
import SaError from './icons/SaError.vue'
import SaInfo from './icons/SaInfo.vue'
import SaSuccess from './icons/SaSuccess.vue'
import Spinner from './icons/Spinner.vue'

@Component({
  components: {
    EButton,
    SaError,
    SaInfo,
    SaSuccess,
    Spinner,
  },
})
export default class Feedback extends Vue {
  @Prop({ required: true }) readonly type!: FeedbackType

  @Prop() readonly title!: string

  @Prop() readonly message!: string

  @Prop() readonly step!: Step

  @Prop({ default: true }) readonly retry!: boolean

  get feedbackIcon(): string {
    switch (this.type) {
      case FeedbackType.success:
        return 'SaSuccess'

      case FeedbackType.error:
        return 'SaError'

      case FeedbackType.info:
        return 'SaInfo'

      case FeedbackType.loading:
        return 'Spinner'

      default:
        return ''
    }
  }

  get retryIsVisible() {
    return this.retry && this.type === FeedbackType.error
  }
}
